import { useFetchCadidateScheldules } from "../../../service/schedule.service";

const useInterview = () => {
  const { isLoading: fetchLoading, data: scheduleList } =
    useFetchCadidateScheldules();
  return { fetchLoading, scheduleList };
};

export default useInterview;
